module.exports = __webpack_public_path__ + "static/img/1.46df166.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/8/eng/1.png
// module id = zUtR
// module chunks = 0